import script from "./CopyToClipboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyToClipboard.vue?vue&type=script&setup=true&lang=js"

import "./CopyToClipboard.vue?vue&type=style&index=0&id=cd9bac9c&lang=css"

const __exports__ = script;

export default __exports__